import styled from 'styled-components';
import { Select } from '@hiiretail/synergy-ui';

export const AttributeSelect = styled(Select)`
  height: 100px;
`;
